import React from 'react';
import CustomerFurnitureDetail from 'components/Tvendo/BusinessPartner/DataMaster/CustomerFurniture/Detail.js';

export default function () {
  return <CustomerFurnitureDetail />;
}
